import { css, styled } from 'styled-components'

import {
  StyledCurrentBidLabel,
  StyledInvoiceButton,
  StyledMaxBidLabel,
  StyledOutbidLabelLabel,
  StyledOutbidPriceLabel,
  StyledSoldPrice,
  StyledWinningBid,
  StyledWonLotLabel,
} from '@nx/bidding-engine'
import { StyledInfoContainer, StyledInfoIcon } from '@nx/fire/info-box'

import {
  StyledBiddingButton,
  StyledBiddingContainer,
} from '@web/components/bidding/BiddingWidget/BiddingWidget.styles'

export const StyledBiddingWidgetWrapper = styled.div`
  ${({ theme }) => css`
    ${StyledBiddingContainer} {
      margin: 10px 0;
    }

    ${StyledCurrentBidLabel} {
      position: relative;
    }

    ${StyledWinningBid} {
      color: ${theme.colours.status.success};
      margin: 0;
    }

    ${StyledMaxBidLabel} {
      color: ${theme.colours.primary.charcoal};
    }

    ${StyledOutbidLabelLabel}, ${StyledOutbidPriceLabel} {
      color: ${theme.colours.status.error};
      margin-bottom: 10px;
    }

    ${StyledBiddingButton} {
      margin: 0;

      &[data-stage='initial'] {
        margin: 2px 0;
      }
    }

    ${StyledWonLotLabel} {
      border-top: 1px solid ${theme.colours.grey['45']};
      border-bottom: 1px solid ${({ theme }) => theme.colours.grey['45']};
      color: ${theme.colours.status.success};
      margin: 10px 0 0;
      padding-top: 10px;
    }

    ${StyledInvoiceButton} {
      justify-content: start;
      margin-top: 8px;
      text-decoration: underline;
      width: 100%;
    }

    ${StyledSoldPrice} {
      border-top: 1px solid ${theme.colours.grey['45']};
      margin: 10px 0 0;
      padding-top: 10px;
    }

    ${StyledInfoContainer} {
      background: none;
      margin: 0;
      padding: 0;
    }

    ${StyledInfoIcon} {
      display: none;
    }
  `}
`
